import * as React from 'react';
import './floatingEventInfo.module.scss';
import iconPlace from '../../course/images/icon-place.png';
import iconCalendar from '../../course/images/icon-calendar.png';
import iconMoney from '../../course/images/icon-money.png';
import { SimpleDate, SimpleTimeRange } from '../../../../admin/components/date/TimeRange';
import { ReserverType } from '../states/EventReservationPageState';
import { EventDetails } from '../../../types/event';
import { getLocationName } from '../../../../mainv3/types/location';

const Section = ({ children }) => <div styleName="section">{children}</div>;
const SectionIcon = ({ src }) => (
    <div styleName="icon-container">
        <img src={src} styleName="icon" />
    </div>
);

const LessonDate = ({ event }) => {
    return (
        <Section>
            <SectionIcon src={iconCalendar} />
            <div styleName="date">
                <SimpleDate date={event.starts_at} />
                <br />
                <SimpleTimeRange range={event} />
            </div>
        </Section>
    );
};

const CourseLocation = ({ locationName }) => {
    return (
        <Section>
            <SectionIcon src={iconPlace} />
            <div styleName="location-name">{locationName}</div>
        </Section>
    );
};

const Price = ({ appliedPrice, priceWithTax }) => {
    return (
        <Section>
            <SectionIcon src={iconMoney} />
            <div>
                {appliedPrice > 0 ? (
                    <span>
                        <span styleName="price">{appliedPrice.toLocaleString()}</span>円（税込{' '}
                        {priceWithTax.toLocaleString()}円）
                    </span>
                ) : (
                    <span>無料</span>
                )}
            </div>
        </Section>
    );
};

type Props = {
    event: EventDetails;
    reserverType: ReserverType;
    membershipAvailable: boolean;
    appliedPrice: number;
};

export class FloatingEventInfo extends React.Component<Props> {
    render() {
        const { event, appliedPrice } = this.props;
        return (
            <div styleName="floating-lesson-info">
                <div styleName="body">
                    <LessonDate event={event} />
                    <CourseLocation locationName={getLocationName(event.location)} />
                    <Price appliedPrice={appliedPrice} priceWithTax={event.price_with_tax} />
                </div>
            </div>
        );
    }
}
